import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { currentYear } from '../../../../../constants/configuration';
import { CustomSelect } from '../../../../commons/CustomSelect';

interface YearSelectProps {
  yearsOptions: string;
  handleYearSelect: (value: string) => void;
  startYear: number | string;
}

export const SessionsYearSelector: FC<YearSelectProps> = ({ yearsOptions, handleYearSelect, startYear }) => {
  const { t } = useTranslation();

  const generatePaymentHistoryYears = (firstYear: number, lastYear: number) => {
    const years: string[] = [];
    for (let i = firstYear; i <= lastYear; i += 1) {
      years.push(`${i}`);
    }
    return years;
  };

  const yearSelectOptions = [
    ...generatePaymentHistoryYears(+startYear, currentYear).map((el) => {
      return { id: el, label: t('serviceManagement.for', { value: el }) };
    }),
    { id: 'for all years', label: t('serviceManagement.forAllYears') },
  ].reverse();

  return (
    <div className="year-selector">
      <CustomSelect
        value={yearsOptions}
        setValue={(e) => handleYearSelect(`${e.target.value}`)}
        items={yearSelectOptions}
      />
    </div>
  );
};
